/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown } from 'react-bootstrap';
import { Grid, TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from 'moment';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  checkQuarterValidation,
  compareQtrs,
  handleScrollToEvent,
  isDateToQuarter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  REBATE_SELECT,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
  API_TIMEOUT_ERROR,
  TO_QTR_CANT_BE_LESS_THAN_FROM,
  FROM_DATE_QTR_REQUIRED,
  TO_DATE_QTR_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  autoFormateDate,
  tabHighLigther,
  validateDate,
  normalizeToDate,
  normalizeDate
} from '../../../../SharedModules/utilities/utilities';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  getNonInvoiceReasonCode,
  setSearchInput,
  setExcludedClaimsGrid,
  getResultGridExcludedClaims,
  setNonInvoiceData,
  setRebateProgramData
} from '../Store/actions';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { QUARTER_FORMAT_ERROR } from '../../../../SharedModules/AppConstants';

export default function ReqExcludedClaims(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList: resultanufacturerList,
    fromDateValue,
    toDateValue,
    excludedClaimsDropDown,
    isAllManufacturerReducer,
    nonInvoiceToggle,
    allNonInvoice: allNonInvoiceValue,
    allRebateProgram: allRebateProgramValue,
    searchResult,
    isNetworkError,
  } = useSelector((state) => state?.sharedState?.ExcludedClaimReducer);
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [dropDownList, setDropDownList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );
  const [toDateToDispatch, setToDateToDispatch] = useState('');
  const [fromDateDispatch, setFromDateToDispatch] = useState('');
  const [errorList, setErrorList] = React.useState(errors);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);
  const [allRebateProgram, setAllRebateProgram] = React.useState(
    allRebateProgramValue
  );
  const [allNonInvoice, setAllNonInvoice] = React.useState(allNonInvoiceValue);

  const [nonInvoiceSelected, setNonInvoiceSelected] = React.useState(
    nonInvoiceToggle || 'CISREV'
  );
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [openNetworkModal, setOpenNetworkError] = useState(false);

  // For No Data validation
  useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  useEffect(() => {
    setOpenNetworkError(isNetworkError);
  }, [isNetworkError]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          disabled: allRebateProgram,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList, allRebateProgram]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
    dispatch(setNonInvoiceData(allNonInvoiceValue))
    dispatch(setRebateProgramData(allRebateProgramValue))

  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  React.useEffect(() => {
    dispatch(getNonInvoiceReasonCode({}));
  }, []);

  React.useEffect(() => {
    const list = excludedClaimsDropDown?.excludedClaimsDropDownVO?.map(
      (val) => ({
        ...val,
        id: val.codeValue,
        name: `${val.codeValue} - ${val.shortDescription}`,
      })
    );
    setDropDownList(list);
  }, [excludedClaimsDropDown]);
                
  // remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [ planType, planTypeList, rebateProgram, fromDate, toDate, allNonInvoice, allRebateProgram, allNonInvoice, nonInvoiceSelected ]);

  // function to validate from Date and toDate on onblur
 const handleOnBlur = (type, input) => {
  const value = autoFormateDate(input)?.toUpperCase() || '';  
  let allErrors = [];
  let fromError = [];
  let toError = [];

  let updatedFrom = fromDate;
  let updatedTo = toDate;

  // ---- FROM DATE ----
  if (type === 'fromDate') {
    setFromDateToDispatch(normalizeDate(value,'from'))
    updatedFrom = value;
    setFromDate(value);

    if (!value) {
      fromError.push({ field: 'fromDate', message: FROM_DATE_QTR_REQUIRED });
    } else if (value.includes('Q')) {
      if (!checkQuarterValidation(value)) {
        fromError.push({ field: 'fromDate', message: QUARTER_FORMAT_ERROR });
      }
    } else {
      fromError = validateDate(value, 'fromDate');
    }

    // auto-fill toDate if empty
    if (!toDate && !fromError.length) {
      updatedTo = value;
      setToDateToDispatch(normalizeDate(value,'to'))
      setToDate(value);
    }
  }

  if (type === 'toDate') {
    setToDateToDispatch(normalizeDate(value,'to'))
    updatedTo = value;
    setToDate(value);

    if (!value) {
      toError.push({ field: 'toDate', message: TO_DATE_QTR_REQUIRED });
    } else if (value.includes('Q')) {
      if (!checkQuarterValidation(value)) {
        toError.push({ field: 'toDate', message: QUARTER_FORMAT_ERROR });
      }
    } else {
      toError = validateDate(value, 'toDate');
    }
  }

    if (fromError.length === 0 && toError.length === 0) {
      if (value.toUpperCase().indexOf('Q') >= 0) {
        if (type === 'fromDate') {
          if (toDate && compareQtrs(value, toDate)) {
            fromError.push({
              field: 'fromDate>toDate',
              message: TO_QTR_CANT_BE_LESS_THAN_FROM,
            });
          }
        }
        if (type === 'toDate') {
          if (compareQtrs(fromDate, value)) {
            toError.push({
              field: 'fromDate>toDate',
              message: TO_QTR_CANT_BE_LESS_THAN_FROM,
            });
          }
        }
      } else if (new Date(fromDate) > new Date(toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
        });
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];
    setErrorList(allErrors);
  };

  const handleSearch = () => {
    let allErrors = [];

  // ---- Rebate Program ----
  if (rebateProgram === '-1' && !allRebateProgram) {
    allErrors.push({
      field: 'rebateProgram',
      message: REBATE_SELECT,
    });
  }

  // ---- Non Invoice ----
  if (nonInvoiceSelected === '-1' && !allNonInvoice) {
    allErrors.push({
      field: 'nonInvoice',
      message: 'Non Invoice Reason code is required',
    });
  }

  let fromError = [];
  let toError = [];

  // ---- FROM DATE ----
  if (!fromDate) {
    fromError.push({ field: 'fromDate', message: FROM_DATE_QTR_REQUIRED });
  } else if (fromDate.includes('Q')) {
    if (!checkQuarterValidation(fromDate)) {
      fromError.push({ field: 'fromDate', message: QUARTER_FORMAT_ERROR });
    }
  } else {
    fromError = validateDate(fromDate, 'fromDate');
  }

  // ---- TO DATE ----
  if (!toDate) {
    toError.push({ field: 'toDate', message: TO_DATE_QTR_REQUIRED });
  } else if (toDate.includes('Q')) {
    if (!checkQuarterValidation(toDate)) {
      toError.push({ field: 'toDate', message: QUARTER_FORMAT_ERROR });
    }
  } else {
    toError = validateDate(toDate, 'toDate');
  }

  // ---- COMMON DATE COMPARISON (ALL 4 CASES COVERED) ----
  if (fromError.length === 0 && toError.length === 0) {
    const from = normalizeToDate(fromDate, 'from');
    const to = normalizeToDate(toDate, 'to');

    if (from && to && from > to) {
      allErrors.push({
        field: 'fromDate>toDate',
        message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
      });
    }
  }

  allErrors = [...allErrors, ...fromError, ...toError];
  setErrorList(allErrors);

  // ---- Stop if errors ----
  if (allErrors.length > 0) return;

  // ---- Prepare rebate program name ----
  let rebateProgramNameObj =
    selectList?.find((item) => item.rebateProgramCd === rebateProgram) || {};

  const rebateProgramName = `${rebateProgramNameObj?.rebateProgramCd} - ${
    rebateProgramNameObj?.shortDescr || ''
  }`;

  dispatch(
    setSearchInput({
      fromDateValue: fromDate,
      toDateValue: toDate,
      errors: allErrors,
      selectedPlanType: planType,
      rebateProgramValue: rebateProgram,
      rebateProgramName,
      nonInvoiceToggle: nonInvoiceSelected,
      dropDownList,
      allRebateProgram,
      allNonInvoice,
      displayObj: {
        rebateProgramName,
        rebateProgramList: rebateProgramListData,
        rebateProgramValue: rebateProgram,
        fromDateValue: fromDate,
        toDateValue: toDate,
        allRebateProgram,
        dropDownList,
        nonInvoiceToggle: nonInvoiceSelected,
      },
    })
  );

  // ---- Continue API call ----
  dispatch(setExcludedClaimsGrid([]));
  setSearchClicked(true);

  dispatch(
    getResultGridExcludedClaims({
      startQuarter: fromDate.includes('Q')
        ? fromDate
        : isDateToQuarter(fromDate),
      endQuarter: toDate.includes('Q')
        ? toDate
        : isDateToQuarter(toDate || fromDate),
      startDate: fromDateDispatch,
      endDate: toDateToDispatch,
      rebateProgram: allRebateProgram ? '' : rebateProgram,
      rebateProgramALL: allRebateProgram ? '1' : '0',
      invReasonCode: allNonInvoice ? '' : nonInvoiceSelected,
      invReasonCodeALL: allNonInvoice ? '1' : '0',
    })
  );
};

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/dispExcludedClaims',
      value: 'Display Excluded Claims',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/dispExcludedClaims',
    });
    dispatch(clearReduxForFilterAndSort('/dispExcludedClaims'));
  }
  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  return (
    <div className='tabs-container'>
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1='State Reports' parent2='Excluded Claims' />

      {openNetworkModal && (
        <DisplayErrorMessages errorMessages={[API_TIMEOUT_ERROR]} />
      )}
      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      <div className='tab-body'>
        <div className='row'>
          <div className='col-4 frr-two-col-radio'>
            <RadioGroupComponent
              data-testid='ExcludedClaims-planType'
              id='filter-plan-by-radio-btn-action'
              labelName='Plan Type'
              required
              optionList={radioList || []}
              defaultValue={planType}
              filterAction={(value) => {
                setPlanType(value);
                setRebateProgram('-1');
                setOpenNetworkError(false);
                const errors = errorList.filter(
                  (error) => error.field !== 'rebateProgram'
                );
                setErrorList([...errors]);
              }}
              className='log-batch-filter-radio frr-checkInvoiceRadio'
            />
          </div>

          <div className='col-6'>
            <Fieldset label='Date/Qtr Range' required>
              <div className='form-wrapper p-0 mt-n3'>
                <div className='mui-custom-form input-md field-xl mandate-fields'>
                  <Grid container spacing={2} alignItems='center'>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label='Start'
                        id='Start'
                        placeholder=''
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        name='From'
                        value={fromDate}
                        error={
                          errorList.filter(
                            (error) =>
                              error.field === 'fromDate' ||
                              error.field === 'fromDate>toDate'
                          )?.length > 0
                            ? 'mandate-fields'
                            : ''
                        }
                        data-testid='ExcludedClaims-Start-from'
                        className='mandate-fields'
                        onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                        onChange={(e) => {
                          const { value } = e.target;
                          setOpenNetworkError(false);
                          setFromDate(value.toUpperCase());
                          setErrorList([
                            ...errorList.filter(
                              (error) =>
                                error.field !== 'fromDate' &&
                                error.field !== 'fromDate>toDate'
                            ),
                          ]);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        label='End'
                        id='End'
                        placeholder=''
                        InputLabelProps={{
                          shrink: true,
                        }}
                        // required={true}
                        inputProps={{ maxLength: 10 }}
                        name='to'
                        value={toDate}
                        data-testid='ExcludedClaims-todate'
                        onBlur={(e) => handleOnBlur('toDate', e.target.value)}
                        onChange={(e) => {
                          setToDate(e.target.value.toUpperCase());
                          setOpenNetworkError(false);
                          setErrorList([
                            ...errorList.filter(
                              (error) =>
                                error.field !== 'toDate' &&
                                error.field !== 'fromDate>toDate'
                            ),
                          ]);
                        }}
                        error={
                          errorList.filter(
                            (error) =>
                              error.field === 'toDate' ||
                              error.field === 'fromDate>toDate'
                          )?.length > 0
                            ? 'mandate-fields'
                            : ''
                        }
                        className='mandate-fields'
                      />
                    </Grid>
                    <Grid xs={12} md={12}>
                      <div
                        className=' Mui-error Mui-required'
                        style={{
                          padding: '0px 10px',
                          color: '#a81f00',
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        {
                          errorList.find(
                            (error) =>
                              error.field === 'fromDate' ||
                              error.field === 'toDate' ||
                              error.field === 'fromDate>toDate'
                          )?.message
                        }
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Fieldset>
          </div>
        </div>
        <div className='row mt-3 mb-2'>
          <div className='col-4 ml-3'>
            <FormControlLabel
              control={
                <Checkbox
                  color='primary'
                  name='allNonInvoiceReasonCode'
                  data-testid='ExcludedClaims-nonInvoice'
                  checked={allNonInvoice}
                  onBlur={() => {}}
                  onChange={() => {
                    setOpenNetworkError(false);
                    setAllNonInvoice(!allNonInvoice);
                    dispatch(setNonInvoiceData(!allNonInvoice))
                    // setAllRebateProgram(!allRebateProgram);
                    if (!allNonInvoice) {
                      const errors = errorList.filter(
                        (error) => error.field !== 'nonInvoice'
                      );
                      setErrorList([...errors]);
                    }
                  }}
                />
              }
              label='All Non Invoice Reason Codes:'
            />
          </div>
          <div className='col-4 ml-2'>
            <FormControlLabel
              control={
                <Checkbox
                  color='primary'
                  name='allRebateProgram'
                  checked={allRebateProgram}
                  data-testid='ExcludedClaims-rebateprogram'
                  onBlur={() => {}}
                  onChange={() => {
                    setOpenNetworkError(false);
                    setAllRebateProgram(!allRebateProgram);
                    dispatch(setRebateProgramData(!allRebateProgram))
                    const tempRadioList = radioList?.map((item) => {
                      return { ...item, disabled: !allRebateProgram };
                    });
                    setRadioList(tempRadioList);
                    if (!allRebateProgram) {
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }
                  }}
                />
              }
              label='All Rebate Programs'
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-4'>
            <>
              <Fieldset label='Non Invoice Reason Code' required>
                <div style={{ marginTop: 18 }}>
                  <SelectBoxComponent
                    disabled={allNonInvoice}
                    data-testid='ExcludedClaims-dropdown'
                    id='filter-plan-by-radio-btn-action'
                    labelName='Non Invoice Reason Code'
                    required
                    select
                    selectOne
                    optionList={dropDownList || []}
                    defaultValue={nonInvoiceSelected}
                    filterAction={(value) => {
                      setNonInvoiceSelected(value);
                      setOpenNetworkError(false);
                      const errors = errorList.filter(
                        (error) => error.field !== 'nonInvoice'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'nonInvoice')
                        ?.message
                    }
                  />
                </div>
              </Fieldset>
            </>
          </div>
          <div className='col-4'>
            <>
              <Fieldset label='Rebate Program' required>
                <div style={{ marginTop: 18 }}>
                  <SelectBoxComponent
                    disabled={allRebateProgram}
                    data-testid='ExcludedClaims-rebateprogram'
                    id='filter-plan-by-radio-btn-action'
                    labelName='Rebate Program'
                    required
                    select
                    selectOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      setOpenNetworkError(false);
                      setRebateProgram(value);
                      setRebateProgramName(value);
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'rebateProgram')
                        ?.message
                    }
                  />
                </div>
              </Fieldset>
            </>
          </div>
        </div>
        <div className='float-right mt-2 hide-on-print'>
          <Button
            data-testid='ExcludedClaims-search'
            className='btn-success same-font-family'
            onClick={() => {
              handleSearch();
            }}
          >
            <SVGComponent iconName='Icon-search' />
            {' Search'}
          </Button>
        </div>
      </div>
    </div>
  );
}
